import { debounce } from 'throttle-debounce'

const createMediaScreen = () => {
  const check = () => {
    const tablet = window.matchMedia('only screen and (min-width: 1024px ) and (max-width: 1359px)').matches

    return {
      mobile: window.matchMedia('only screen and (max-width: 1023px)').matches,
      tablet,
      desktop: tablet || window.matchMedia('only screen and (min-width: 1360px)').matches,
    }
  }

  const medias = check()

  const onChange = (handler) => {
    handler(check())

    window.addEventListener('resize', debounce(600, () => {
      handler(check())
    }))
  }

  return {
    ...medias,
    onChange,
  }
}

export default createMediaScreen
